import axios from 'axios'
import {AppConfigModel} from '../../../models/app-config/AppConfigModel'
import {LanguageModel} from '../../../models/LanguageModel'

export const GetAppConfig = () => axios.get<AppConfigModel[]>('/config-group/app')
export const GetAllLanguages = () => axios.get<LanguageModel[]>(`/language`)
